export enum Role {
  Administrator = 11, // Администратор
  Clerk = 21, // Делопроизводитель
  User = 22, // Пользователь
  Synchronizer = 23, // Синхронайзер
  GeneralManager = 24, // Менеджер главный
  Manager = 25, // Менеджер
}
